/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import { connect } from 'react-redux';
import { exportParticipantArchive, hideModal, showModal } from '../../../actions/actions';
import ParticipantArchiveExportModal from './participant-archive-export.modal';

export const mapStateToProps = (state, ownProps) => {
  return {
    study: state.subject.participantStudy,
    user: state.login.user
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    close: () => {
      dispatch(hideModal());
    },
    initiateArchiveExport: ({ study, username, studyProtocolNumber }) => {
      dispatch(exportParticipantArchive({ study, username, studyProtocolNumber }));
    }
  };
};

const ParticipantArchiveExportModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ParticipantArchiveExportModal);
export default ParticipantArchiveExportModalContainer;
